import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/system/device/device';
import { ceretBooksInfo, ceretLongBooksInfo } from '@/api/PMS/placeBookInfo/placeBookInfo.js';
import { fetchListByType } from '@/api/system/dic/dic'; // import { fetchTreeList as floorTree } from '@/api/system/floor/floor'
// import { fetchList as fetchTargetList } from '@/api/system/target/target'

import waves from '@/directive/waves'; // 水波纹指令

import deviceAdd from './add';
export default {
  components: {
    deviceAdd: deviceAdd
  },
  name: 'complexTable',
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      floorOption: [],
      floorTreeProps: {
        label: 'name',
        value: 'id',
        children: 'childDev'
      },
      brandOption: [],
      sysTypeOption: [],
      targetOption: [],
      list: null,
      total: null,
      listLoading: true,
      floorIds: [],
      listQuery: {
        page: 1,
        limit: 10
      },
      title: '',
      deviceId: -1,
      multipleSelection: [],
      dialogFormVisible: false
    };
  },
  created: function created() {
    if (Object.keys(this.$route.params).length > 0) {
      this.listQuery.targetName = this.$route.params.targetName;
      this.listQuery.sysType = this.$route.params.sysTye;
      this.listQuery.deviceState = this.$route.params.deviceState;
    } // this.loadTarget()


    this.loadBrand();
    this.loadSysType(); // this.loadFloor()

    this.getList();
  },
  methods: {
    loadTarget: function loadTarget() {
      var _this = this;

      fetchTargetList({}).then(function (r) {
        _this.targetOption = r.data.data;
      });
    },
    loadFloor: function loadFloor() {
      var _this2 = this;

      floorTree({}).then(function (r) {
        _this2.floorOption = r.data.data;
      });
    },
    loadBrand: function loadBrand() {
      var _this3 = this;

      fetchListByType('brand_name').then(function (r) {
        _this3.brandOption = r.data.data;
      });
    },
    loadSysType: function loadSysType() {
      var _this4 = this;

      fetchListByType('sys_type').then(function (r) {
        _this4.sysTypeOption = r.data.data;
      });
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this5 = this;

      this.listLoading = true; // if (this.floorIds.length > 0) {
      //   this.listQuery.floorId = this.floorIds[this.floorIds.length - 1]
      // } else {
      //   delete this.listQuery.floorId
      // }

      fetchList(this.listQuery).then(function (response) {
        _this5.list = response.data.data;
        _this5.total = response.data.total;
        _this5.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.deviceId = -1;
      this.title = '创建';
      this.dialogFormVisible = true;
    },
    handlePlaceCreate: function handlePlaceCreate() {
      var _this6 = this;

      ceretBooksInfo().then(function () {
        _this6.Alert({
          alertType: 'add',
          message: '操作成功'
        });
      });
    },
    handlePlaceLock: function handlePlaceLock() {
      var _this7 = this;

      this.$confirm('根据当前配置信息更新锁场, 是否继续?', '提示').then(function () {
        ceretLongBooksInfo().then(function () {
          _this7.Alert({
            alertType: 'add',
            message: '操作成功'
          });
        });
      });
    },
    // 编辑
    handleUpdate: function handleUpdate(deviceId) {
      this.deviceId = deviceId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(deviceIds) {
      var _this8 = this;

      if (deviceIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(deviceIds).then(function (response) {
            _this8.getList();

            _this8.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(deviceId) {
      var deviceIds = [];
      deviceIds.push(deviceId);
      this.delete(deviceIds);
    },
    handleDeletes: function handleDeletes() {
      var deviceIds = [];
      this.multipleSelection.forEach(function (row) {
        deviceIds.push(row.deviceId);
      });
      this.delete(deviceIds);
    }
  }
};